import React from 'react'

function Raffles() {
  return (
    <div>Raffles</div>
  )
}

export default Raffles